var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18.05,
    viewBox: "0 0 24 18.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-Color",
    className: "cls-1",
    d: "M12,3c3.38,0,6.34,1.63,8.85,4.31a20.44,20.44,0,0,1,2.25,2.88c.28.45.5.82.66,1.1h0l.12.25a1,1,0,0,1,0,1c-.14.28-.4.75-.78,1.35a20.44,20.44,0,0,1-2.25,2.88c-2.51,2.68-5.47,4.31-8.85,4.31s-6.34-1.63-8.85-4.31A20.44,20.44,0,0,1,.9,13.86c-.28-.45-.5-.82-.66-1.1h0l-.12-.25a1,1,0,0,1,0-1c.14-.28.4-.75.78-1.35A20.44,20.44,0,0,1,3.15,7.31C5.66,4.63,8.62,3,12,3Zm0,2.18c-2.69,0-5.13,1.34-7.26,3.62a17.55,17.55,0,0,0-2,2.58c-.1.15-.2.3-.28.44h0l-.12.2.25.43h0l.15.22a17.55,17.55,0,0,0,2,2.58c2.13,2.27,4.57,3.62,7.26,3.62s5.13-1.35,7.26-3.62a17.55,17.55,0,0,0,2-2.58c.1-.15.2-.3.28-.44h0l.12-.21-.25-.42h0l-.15-.22a17.55,17.55,0,0,0-2-2.58C17.13,6.52,14.69,5.18,12,5.18ZM12,8A4.07,4.07,0,1,1,7.93,12,4.07,4.07,0,0,1,12,8Zm0,2.18A1.89,1.89,0,1,0,13.88,12,1.88,1.88,0,0,0,12,10.14Z",
    transform: "translate(0 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c202e319b41022d3eebb9de8fe029270.svg";
export { ForwardRef as ReactComponent };